import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule } from '@norfolk-southern/accessns-components';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { ThirdApplicationsComponent } from '@ruby/modules/third-party/submodules/third-grid/components/third-cell/third-applications/third-applications.component';
import { ThirdContactDetailsComponent } from '@ruby/modules/third-party/submodules/third-grid/components/third-cell/third-contact-details/third-contact-details.component';
import { ThirdGridComponent } from '@ruby/modules/third-party/submodules/third-grid/components/third-grid.component';
import { ThirdHeaderComponent } from '@ruby/modules/third-party/submodules/third-grid/components/third-header/third-header.component';
import { ThirdPartyActionsContainerComponent } from '@ruby/modules/third-party/submodules/third-grid/containers/third-actions/third-actions.container';
import { ThirdPartyGridContainerComponent } from '@ruby/modules/third-party/submodules/third-grid/containers/third-grid.container';
import { ThirdPartyHeaderContainerComponent } from '@ruby/modules/third-party/submodules/third-grid/containers/third-header/third-header.container';
import { ThirdPartyGridRoutingModule } from '@ruby/modules/third-party/submodules/third-grid/third-party-grid-routing.module';
import { PureUserInformationModule } from '@ruby/shared/components/user-information/pure-user-information.module';
import { ThirdPartyDialogModule } from '@ruby/shared/dialogs/third-party/third-party.dialog.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    ThirdPartyGridContainerComponent,
    ThirdGridComponent,
    ThirdPartyHeaderContainerComponent,
    ThirdHeaderComponent,
    ThirdPartyActionsContainerComponent,
    ThirdApplicationsComponent,
    ThirdContactDetailsComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatToolbarModule,
    PureUserInformationModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    ThirdPartyGridRoutingModule,
    ThirdPartyDialogModule,
    SweetAlert2Module
  ],
  exports: [ThirdPartyGridContainerComponent]
})
export class ThirdPartyGridModule {}
